// FutureLab
import { DesktopFeedback } from '../components/feedback/DesktopFeedback';

export function FeedbackSessionPage() {
	return <DesktopFeedback />;
}
